import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tickets-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "fw-semibold text-body" }
const _hoisted_7 = { class: "reviews" }
const _hoisted_8 = { class: "ticket-title d-block fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20\" data-v-5b2041f2><h5 class=\"mb-0\" data-v-5b2041f2>Tickets</h5><div class=\"dropdown action-opt\" data-v-5b2041f2><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-5b2041f2><i class=\"ri-more-2-fill\" data-v-5b2041f2></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-5b2041f2><li data-v-5b2041f2><button class=\"dropdown-item\" data-v-5b2041f2>This Day</button></li><li data-v-5b2041f2><button class=\"dropdown-item\" data-v-5b2041f2>This Week</button></li><li data-v-5b2041f2><button class=\"dropdown-item\" data-v-5b2041f2>This Month</button></li><li data-v-5b2041f2><button class=\"dropdown-item\" data-v-5b2041f2>This Year</button></li></ul></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets.slice(0, 7), (ticket) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: ticket.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(ticket.id), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(ticket.title), 1),
                    _createElementVNode("p", null, "Updated on: " + _toDisplayString(ticket.updatedOn), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`trezo-badge ${ticket.statusClass}`)
                    }, _toDisplayString(ticket.status), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}